// extracted by mini-css-extract-plugin
module.exports = {"container":"_2SuPNxJgmucMVWzZ05Tg_5","heading":"_2taCTzvo9jJpjqHt3Ont54","items":"_18WRdkV6nAPL-mlP40wxUm"};